<script lang="ts">
  import { t } from '$lib/translations'
  import * as Sheet from '$lib/components/ui/sheet'
  import { Menu } from 'lucide-svelte'
  import type { LangKeys, NavItem } from '$lib/types'
  import { LANGS_FOR_DROPDOWN } from '$lib/constants'
  import { langValueToIcon, langLabelToValue } from '$lib/utils'

  export let navItems: NavItem[]
  export let selectedLangValue: LangKeys
</script>

<Sheet.Root>
  <Sheet.Trigger>
    <span class="flex flex-row gap-1 uppercase"><Menu class="text-cs-orange" size={30} /></span>
  </Sheet.Trigger>
  <Sheet.Content side="left" class="bg-cs-orange text-white">
    <Sheet.Close class="text-left">
    <div class="grid gap-4 py-4">
      <ul>
        {#each navItems as item}
          <li class="text-2xl my-2 uppercase"><a href={item.path}>{$t(item.label)}</a></li>
          {/each}
          <hr class="my-3">
          {#each LANGS_FOR_DROPDOWN as lang}
          <li class="text-xl">
            <button class="p-2" on:click={() => selectedLangValue = langLabelToValue[lang.label]}>
              <svelte:component this={langValueToIcon[lang.label]}/>
            </button>
          </li>
          {/each}
        </ul>
      </div>
    </Sheet.Close>
  </Sheet.Content>
</Sheet.Root>